export default "__VITE_ASSET__Bfpp5Gun__";